import React, {Component} from "react";
import DashboardOitSelect from "./DashboardOitSelect";
import './DashboardOitReport.scss'
import classNames from 'classnames'

class DashboardOitReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      oitGuid: '',
      expanded: false
    }

    this.onPopState = this.onPopState.bind(this)
  }

  get hasSelected() {
    if(this.props.multiple) {
      return this.state.oitGuid && this.state.oitGuid.length
    }
    return this.state.oitGuid
  }

  toggleExpanded() {
    if(this.state.expanded) {
      this.setState({expanded: false, oitGuid: ''})
      document.body.classList.remove('report-opened')
        window.removeEventListener('popstate', this.onPopState)
        setTimeout(() => {
            history.back()
        })
    } else {
      document.body.classList.add('report-opened')
        const url = new URL(location);
        url.searchParams.set("title", this.props.title);
        history.pushState({}, "", url);
        window.addEventListener('popstate', this.onPopState)
      this.setState({expanded: true})
    }
  }
  onPopState(event) {
    if(this.state.expanded) {
      this.setState({expanded: false, oitGuid: ''})
        document.body.classList.remove('report-opened')
    }
  }
  render() {
    return (
      <div className={classNames("dashboard-oit-report", {'expanded': this.state.expanded})}>
        <div className="dashboard-oit-report-title" onClick={() => this.toggleExpanded()}>
          {this.props.title}
          {!this.state.expanded && <i className="fa fa-expand"></i>}
          {this.state.expanded && <button className="primary small button"><i className="fa fa-times"></i> Close </button>}
        </div>
        <div className="dashboard-oit-report-selection">
          <DashboardOitSelect
            value={this.state.oitGuid}
            onInput={(oitGuid) => this.setState({oitGuid})}
            expanded={this.state.expanded}
            multiple={this.props.multiple}
          >
            {!this.state.expanded && <button className="primary small button"
                     onClick={() => this.toggleExpanded()}>View</button>}
          </DashboardOitSelect>
        </div>
        { this.state.expanded && this.hasSelected && this.props.children && this.props.children(this.state.oitGuid) || null}
        <div className="dashboard-out-report-footer">
          Data only available if recorded in your program
        </div>
      </div>
    );
  }
}

export default DashboardOitReport;
